<template>
	<div>

		<div
			class="boton-flotante"
		>
			<div v-if="value.habilitado && value.medio && value.texto">
				<a
					class="boton-flotante-texto"
					target="_blank"
					:href="asegurarURL(value.medio, contacto.medios[value.medio].valor)"
				>{{ value.texto }}</a>
			</div>
			<VContactoBotonEnlace
				v-if="value.habilitado && value.medio"
				:medio="value.medio"
				:valor="contacto.medios[value.medio].valor"
				:tamaño="value.tamaño"
			></VContactoBotonEnlace>

			<div style="padding-left: 5px">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							v-bind="attrs"
							v-on="on"
							@click="configurando = true"
							style="background-color: white">
							<v-icon>mdi-cog</v-icon>
						</v-btn>
					</template>
					<span>Configurar botón flotante</span>
				</v-tooltip>
			</div>

		</div>

		<v-dialog
      v-model="configurando"
      max-width="500"
    >
      <v-card>
				<v-card-title>Configuración de botón flotante de contacto</v-card-title>
				<v-card-text>
					<v-form>

						<v-switch
							v-model="value.habilitado"
							label="Habilitar botón flotante"
						></v-switch>

						<v-radio-group
							v-model="value.medio"
							:disabled="!value.habilitado"
						>
							<v-radio
								v-for="m in medios"
								:key="m.v"
								:value="m.v"
							>
								<template v-slot:label>
									<div class="etiqueta-medio">
										<VContactoBoton :medio="m.v" tamaño="20px" style="display: inline"></VContactoBoton>
										<div>
											{{ m.n }}
											<span
												v-if="contacto.medios[m.v].valor"
												style="font-size: 75%;"
												class="text--disabled"
											>({{ contacto.medios[m.v].valor }})</span>
										</div>
									</div>
								</template>
							</v-radio>
						</v-radio-group>

						<v-text-field
							v-model="value.texto"
							label="Texto que acompaña el botón"
							:disabled="!value.habilitado"
						></v-text-field>

						<v-slider
							v-model="tamaño"
							label="Tamaño del ícono"
							class="mt-4"
							thumb-label="always"
							:thumb-size="24"
							:step="10"
							:min="50"
							:max="100"
							ticks
							:tick-size="5"
							:disabled="!value.habilitado"
						></v-slider>

						<p>NOTA: Puede configurar los medios de contacto en el botón «CONFIGURACIÓN», arriba a la derecha.</p>

					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn text @click="configurando = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

	</div>
</template>

<script>
import VContactoBotonEnlace from '@/components/base/VContactoBotonEnlace.vue'
import VContactoBoton from '@/components/base/VContactoBoton.vue'
import { asegurarURL } from '@/contactoExterno'

export default {
	name: 'ContactoBotonFlotante',

	data: () => ({
		medios: [
			{
				v: 'whatsapp',
				n: 'Whatsapp'
			},
			{
				v: 'instagram',
				n: 'Instagram'
			},
			{
				v: 'facebook',
				n: 'Facebook'
			},
			{
				v: 'twitter',
				n: 'Twitter'
			},
			{
				v: 'youtube',
				n: 'Youtube'
			},
			{
				v: 'linkedin',
				n: 'Linkedin'
			},
			{
				v: 'correoElectrónico',
				n: 'Correo electrónico'
			},
			{
				v: 'númeroTelefónico',
				n: 'Número telefónico'
			},
		],

		configurando: false,

		tamaño: 50
	}),

	components: {
		VContactoBotonEnlace,
		VContactoBoton
	},

	props: {
		value: {
			type: Object,
			required: true
		},
		contacto: {
			type: Object,
			required: true
		}
	},

	watch: {
		'tamaño': function(v) {
			this.value.tamaño = `${v}px`
		}
	},

	mounted: function() {
		let v = (this.value.tamaño || '').trim().replace('px', '').replace('em', '')
		this.tamaño = Number(v)
	},

	methods: {
		asegurarURL: asegurarURL
	}

}

</script>

<style scoped>

.v-application a {
	color: #555;
}

.boton-flotante {
	right: 300px;
}

.etiqueta-medio {
	display: table;
}

.etiqueta-medio > div {
	display: table-cell;
	vertical-align: middle;
}

.etiqueta-medio > div:last-child {
	padding-left: 5px;
}

</style>